import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteNetworkElement } from '@api/networkElements';

import { INetworkElement } from '@interfaces/networkElements/networkElements';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { NETWORK_ELEMENTS_DELETE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateNetworkElements from './useInvalidateNetworkElements';

interface IUseMutateNetworkElementsDeleteReturned {
	deleteNetworkElement: (id: string) => void;
	isLoadingDeleteNetworkElement: boolean;
}

const useMutateNetworkElementsDelete = (handleCloseModal: () => void): IUseMutateNetworkElementsDeleteReturned => {
	const dispatch = useAppDispatch();
	const invalidateNetworkElements = useInvalidateNetworkElements();

	const {
		isLoading,
		mutate,
	} = useMutation<string>({
		mutationKey: [NETWORK_ELEMENTS_DELETE],
		mutationFn: deleteNetworkElement,
		onSuccess: (data: INetworkElement) => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.networkElementDeleted(data.name),
				type: ESnackbarTypes.success,
			}));

			return invalidateNetworkElements();
		},
		allowedRoles: [EUserRoles.smoLightUpdater],
	});

	return {
		deleteNetworkElement: mutate,
		isLoadingDeleteNetworkElement: isLoading,
	};
};

export default useMutateNetworkElementsDelete;
